<script setup>
import { onBeforeUnmount, ref, watch } from 'vue';

// Contador com tween (não existe no design system). Respeita prefers-reduced-motion.
const props = defineProps({
  value: { type: Number, default: 0 },
  duration: { type: Number, default: 320 },
});

const display = ref(props.value);
const pop = ref(false);
let raf = null;
let popTimer = null;

const prefersReduced = () =>
  window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

watch(
  () => props.value,
  (to, from) => {
    pop.value = true;
    clearTimeout(popTimer);
    popTimer = setTimeout(() => {
      pop.value = false;
    }, 220);

    if (prefersReduced()) {
      display.value = to;
      return;
    }

    cancelAnimationFrame(raf);
    const start = performance.now();
    const tick = now => {
      const progress = Math.min(1, (now - start) / props.duration);
      const eased = 1 - Math.pow(1 - progress, 4); // easeOutQuart
      display.value = Math.round(from + (to - from) * eased);
      if (progress < 1) raf = requestAnimationFrame(tick);
      else display.value = to;
    };
    raf = requestAnimationFrame(tick);
  }
);

onBeforeUnmount(() => {
  cancelAnimationFrame(raf);
  clearTimeout(popTimer);
});
</script>

<template>
  <span
    class="px-1.5 text-xs font-medium rounded-full bg-n-alpha-2 text-n-slate-11 tabular-nums transition-transform duration-200"
    :class="{ 'scale-125 !bg-n-brand/15 !text-n-brand': pop }"
  >
    {{ display }}
  </span>
</template>
